/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S6_Li1Inputs */

const en_guide_large_json_files_s6_li1 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files under <strong>5 MB</strong>: All tools work smoothly`)
};

const ko_guide_large_json_files_s6_li1 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>5 MB</strong> 미만 파일: 모든 도구가 원활하게 작동`)
};

const ja_guide_large_json_files_s6_li1 = /** @type {(inputs: Guide_Large_Json_Files_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>5MB</strong>未満のファイル: すべてのツールがスムーズに動作`)
};

/**
* | output |
* | --- |
* | "Files under <strong>5 MB</strong>: All tools work smoothly" |
*
* @param {Guide_Large_Json_Files_S6_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s6_li1 = /** @type {((inputs?: Guide_Large_Json_Files_S6_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S6_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s6_li1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s6_li1(inputs)
	return ja_guide_large_json_files_s6_li1(inputs)
});